// extracted by mini-css-extract-plugin
module.exports = {"toc":"toc-module--toc--3kLiI","active":"toc-module--active--nw3Y6"};